module.exports = __webpack_public_path__ + "static/newsletter-form-d68915134b9be7ffda0d610006296396.jpg";